<template>
  <div v-if="visible" class="overlay-background">
    <div class="overlay">
      <p class="overlay-message">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.overlay-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: bg-fade-animation 2s ease forwards; /* Fade in/out animation for the background */
}

.overlay {
  background-color: var(--accent-color); /* Same color as in AddCharacter */
  color: var(--secondary-color);
  padding: 20px 40px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: bold;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  animation: overlay-juicy-animation 2s ease forwards;
}

/* Keyframe animation for juicy effect */
@keyframes overlay-juicy-animation {
  0% {
    opacity: 0;
    transform: scale(0.8); /* Start smaller */
  }
  25% {
    opacity: 1;
    transform: scale(1.1); /* Scale up slightly */
  }
  50% {
    transform: scale(1); /* Ease into normal size */
  }
  80% {
    transform: scale(1.05); /* Anticipation */
  }
  100% {
    opacity: 0;
    transform: scale(0.9); /* Fade out while shrinking */
  }
}

/* Fade in and out for background */
@keyframes bg-fade-animation {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  100% {
    opacity: 0; /* Fades out at the end */
  }
}
</style>
